import React, { useEffect, useState } from "react";
import { AxiosResponse,AxiosError } from "axios";
import { Result, refilLimit } from "../../interface/RefillLimit";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/ui/button";
import { RefillLimitAxiosInstance } from "../../Network/RefillLimitAxiosInstance";
import { Option } from "../../interface/Option";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import DataTable2 from "shared/DataTable2";
import ListofActivityCode from "../Shared/ListOfActivityCode"
import ActivitySelector from "../Shared/ActivityType";
const RefillLimit: React.FC = () => {
    // Main data state
   const [items, setItems] = useState<refilLimit>({ result: [] });

  // Form states
 const [Name, setName] = useState<string>("");
  const [ActivityType, setActivityType] = useState<string>("");
  const [activityCode, setActivityCode] = useState<Option[]>([]); 
  const [RefillLimit, setRefillLimit] =  useState<number >(0);

   // UI control states
 const [editIndex, setEditIndex] = useState<null | number>(null);
 const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [clearActivityCode, setClearActivityCode] = useState(false);
  const [activityTypeisValid, setActivityTypeIsValid] = useState<boolean>(true); 
// Get token from localStorage
  const token = localStorage.getItem("token") || "";

  // Initialize toast
  const { toast } = useToast();

const clear= () =>{
  setName("");
     setActivityType("");
  setActivityCode([]);
 setRefillLimit(0);
}
useEffect(() => {
  fetchItems();
}, []);

  const handleEditClick = (item: Result) => {
    handleEdit(item);
    setIsDialogOpen(true); }

    const handleAddClick = () => {
      setEditIndex(null);
      clear();
      setIsDialogOpen(true); }

 

     
  const handleActivityTypeChange = (ActivityType: string) => {
    setActivityType(ActivityType); //Update the status of the selected activityType
  };
 const handleActivityChange = (selectedOptions: Option[]) => {
          console.log("selected:", selectedOptions);
          setActivityCode(selectedOptions);};


// API functions
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await RefillLimitAxiosInstance.get("getRefill");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
      toast({
        title: "Error",
        description: "Failed to fetch Refill Limit Groups",
        variant: "destructive",
      });
    }
  };

  const addItem = async (): Promise<void> => {
    if (!Name.trim() ) {
      toast({
        title: "Error",
        description: " Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (Name.trim().length < 3 ) {
      toast({
        title: "Error",
        description: " Name must be at least 3 characters long.",
        variant: "destructive",
      });}
   const ValuesActivitycode = activityCode.map((option) => option.value);
   try {

      const newGroupArray = 
        {
          relation_name:Name,
            activity_type: ActivityType,
            activity_code: ValuesActivitycode,
            refill_limit: RefillLimit,
            token: token,
    }
      
    console.log(newGroupArray);
   const response = await RefillLimitAxiosInstance.post("addRefill", newGroupArray);
  if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
       toast({
            title: "Success",
            description: "New Relation Refill Limit Group Added Successfully.",
          });
        } else {
          if (response.data.errors && response.data.errors.length > 0) {
            const errorDetails = response.data.errors[0]; 
            const errorMessage =
              errorDetails.error ||
              "Failed to add the group due to an unknown error.";
            toast({
              title: "Error",
              description: errorMessage,
            });
            console.log(errorMessage);
          } else {
            toast({
              title: "Error",
              description: response.data.error || "Failed to add the group.",
              variant: "destructive",
            });
            console.log(response.data.error);
          }
        }
      } catch (error: AxiosError | any) {
        toast({
          title: "Error",
          description:
            error.response?.data?.error || "An unexpected error occurred.",
            variant: "destructive",
        });
        console.error(error.response?.data?.error || error.message);
      }
  
  };


 const updateItem = async (id: string | number): Promise<void> => {
  if (!Name.trim() ) {
    toast({
      title: "Error",
      description: " Name is required and cannot be empty.",
      variant: "destructive",
    });
    return;
  }
  if (Name.trim().length < 3 ) {
    toast({
      title: "Error",
      description: " Name must be at least 3 characters long.",
      variant: "destructive",
    });}
    const ValuesActivitycode = activityCode.map((option) => option.value);
 const updatedItem = {
  relation_name:Name,
        activity_type: ActivityType,
        activity_code: ValuesActivitycode,
        refill_limit: RefillLimit,
            id: id,
        
        token: token,
    };

    console.log("updatedItem",updatedItem);

    try {
        const response = await RefillLimitAxiosInstance.put(
            `updateRefill`,
            updatedItem
        );

        if (response.data.success) {
            fetchItems();
            clear();
            setIsDialogOpen(false);
            toast({
                title: "Success",
                description: "Relation Refill Limit Group updated successfully.",
            });
        }
    } catch (error: AxiosError | any) {
        console.error("Error during the request: ", error);
        toast({
            title: "Error",
            description:
                error.response?.data?.error || "An unexpected error occurred.",
            variant: "destructive",
        });
    }
};

  const deleteItem = async (id: string | number): Promise<void> => {
    try {
      const response: AxiosResponse = await RefillLimitAxiosInstance.delete(
        `deleteRefill/${id}`, {
      
           data: { token: token }, 
         }
      );
      if (response.data.success) {
        console.log("Refill Limit Relation  Deleted Successfully:", response.data);
        fetchItems();
        toast({
          title: "Success",
          description: "Refill Limit Relation Deleted Successfully.",
        });
      } else {
        toast({
          title: "Error",
          description: response.data.error||"Failed to delete Relation Refill Limit.",
          variant: "destructive",
        });
        console.error("Error deleting Relation Refill Limit:",);
      }
    } catch (error) {
      toast({
        title: "Error",
        description:"Failed to delete Relation Refill Limit.",
        variant: "destructive",
      });
    }
  };


const handleEdit = (item: Result) => {
   const mapToOptions = (arr: (string | number)[]): Option[] =>
        arr.map((value) => ({
          value: value, // Actual value
          label: value.toString(), // The text that will appear in the Select
        }));
    
setName(item.relation_name);
    setActivityType(item.activity_type);
    setActivityCode(mapToOptions(item.activity_code));
    setRefillLimit(item.refill_limit);
    setEditIndex(item.id);
};

  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
     {
          accessorKey: "relation_name",
          header: ({ column }) => (
            <Button
              variant="ghost"
              onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            >
              Name
              {column.getIsSorted() === "asc"
                ? " ↑"
                : column.getIsSorted() === "desc"
                ? " ↓"
                : ""}
            </Button>
          ),
        },
    {
      accessorKey: "activity_type",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Activity Type
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    }, 
      {
            accessorKey: "activity_code",
            header: ({ column }) => (
              <Button
                variant="ghost"
                onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
              >
               Activity Code
                {column.getIsSorted() === "asc"
                  ? " ↑"
                  : column.getIsSorted() === "desc"
                  ? " ↓"
                  : ""}
              </Button>
            ), 
             cell: ({ row }) => {
              const  Activity= row.getValue("activity_code") as string[];
              return Array.isArray( Activity) ?   Activity.join(", ") :   Activity;
            },
            
          },
    {
      accessorKey: "refill_limit",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        FrequencyLimit
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    }, 
  
   ];

 
  return (
    <div className=" h5-container mx-auto p-8">
    <h5 className="mb-6 flex items-center gap-2" style={{fontWeight:"bolder" ,fontSize:"22px",  marginTop:"15px"}}>
    <span className="icon-container">
                    <i className="fa-solid fa-list"></i>
                </span>
                Refill Limit </h5>
     
      {/* model */}
      {/* tabIndex="-1" */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
  <DialogContent>
    <DialogHeader>
      <DialogTitle>
        {editIndex === null ? "Add Relation Refill Limit Group" : "Edit Relation Refill Limit Group"}
      </DialogTitle>
      </DialogHeader>

    <div className="grid grid-cols-2 gap-4 mt-4">
      {/* First Column */}
      <div>
            <div className="mb-4">
             <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            value={Name}
            onChange={(e) => setName(e.target.value)}  
          placeholder="Name is required  "
          />
        
        </div>
      <div className="mb-4">
              <label className="form-label">Activity Type:</label>
                  
              <ActivitySelector 
  onSelectActivity={handleActivityTypeChange}
  selectedActivityType={ActivityType} />
</div>


  
      </div>  
      {/* Second Column */}
      <div>
      <div className="mb-4">
              <Label htmlFor="RefillLimit">Refill Limit</Label>
            <Input
              id="RefillLimit"
              value={RefillLimit} 
              onChange={(e) => setRefillLimit(Number(e.target.value))}    
               placeholder="Enter Refill Limit"
            />
      </div>
        {ActivityType && (
                                <div className="mb-4">

                         <Label htmlFor="ActivityCode">Activity Code:</Label>
                         <ListofActivityCode
               onChange={handleActivityChange}
               type={ActivityType}
               defaultValue={activityCode}  
               clear={clearActivityCode}
               isValid={ activityTypeisValid}
             />
                </div>
                )}
          </div>
   
    </div>

    <DialogFooter className="gap-2 m-4">
      <Button
        onClick={() => {
          if (editIndex === null) {
            addItem();
          } else {
            updateItem(editIndex);
          }
        }}
        className="bg-blue-600 hover:bg-blue-700"
      >
        {editIndex === null ? "Add relation " : "Update Relation "}
      </Button>
      <Button
        variant="outline"
        onClick={() => {
          setEditIndex(null);
          clear();
          setIsDialogOpen(false);
        }}
      >
        Cancel
      </Button>
    </DialogFooter>
  </DialogContent>
</Dialog>


 {/* table */}

      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={["relation_name"]}
        addButtonLabel="Add New Relation "
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={deleteItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
 
/>

    <Toaster />
    </div>
  );
};

export default RefillLimit  ;


